import { OrgUserSearchParams } from '@cibo/core'
import { Paper, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { UserSearchChipComponents, UserSearchChipName } from './UserSearchChipComponents'

export const filterCount = (filters: OrgUserSearchParams) => {
  let count = 0

  if (filters.acresGt || filters.acresLt) count++

  count += filters.persona?.length || 0
  count += filters.fips?.length || 0
  count += !!filters.orgId ? 1 : 0
  count += !filters.isActive ? 1 : 0

  return count
}

const filterPresentationOrder: UserSearchChipName[] = [
  'isActive',
  'persona',
  'orgId',
  'fips',
  'acresLt',
  'acresGt',
]

export const UserSearchChips = ({
  searchValues,
  onSearch,
}: {
  searchValues: OrgUserSearchParams
  onSearch(searchValues: OrgUserSearchParams): void
}) => {
  const { t } = useTranslation('@cibo/profile/PaginatedUsersTable')

  const handleUpdate = (newFilters: OrgUserSearchParams) => {
    onSearch(newFilters)
  }

  if (filterCount(searchValues) === 0) {
    return null
  }

  return (
    <Paper elevation={0} sx={{ backgroundColor: 'background.default', p: 1.5 }}>
      <Stack
        direction="row"
        spacing={1.5}
        flexWrap="wrap"
        alignItems="start"
        sx={{
          width: '100%',
        }}
      >
        {filterPresentationOrder.map(filterName => {
          const FilterChipComponent = UserSearchChipComponents[filterName]

          return (
            <FilterChipComponent
              searchValues={searchValues}
              handleUpdate={handleUpdate}
              t={t}
              key={filterName}
            />
          )
        })}
      </Stack>
    </Paper>
  )
}
